export default __webpack_public_path__ + "static/media/lUSDC.f347e580.png";